import { baseAxios, errorHandler } from "../index";

export async function getAllTotalPengajuanProduktif(dispatch, data, history) {
  // console.log(data, "LL");
  try {
    const response = await baseAxios.post(
      "webPengajuanProduktif/getAllTotalPengajuan",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({
      type: "SET_AMBIL_PENGAJUAN_PRODUKTIF",
      data: response.data.data,
    });
    dispatch({
      type: "SET_ALL_TOTAL_PENGAJUAN_PRODUKTIF",
      data: response.data,
    });
    // console.log(response, "PP");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllTotalSupervisorProduktif(dispatch) {
  try {
    const response = await baseAxios.get(
      "webDashboardProduktif/getTotalSupervisor",
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    // console.log(response, "???????????");
    dispatch({
      type: "SET_ALL_TOTAL_SUPERVISOR_PRODUKTIF",
      data: response.data,
    });
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllTotalAreaManagerProduktif(dispatch) {
  try {
    const response = await baseAxios.get(
      "webDashboardProduktif/getTotalAreaManager",
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({
      type: "SET_ALL_TOTAL_AREAMANAGER_PRODUKTIF",
      data: response.data,
    });
    // console.log(response, "???????????");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllTotalMarketingProduktif(dispatch) {
  try {
    const response = await baseAxios.get(
      "webDashboardProduktif/getTotalMarketing",
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({
      type: "SET_ALL_TOTAL_MARKETING_PRODUKTIF",
      data: response.data,
    });
    // console.log(response, "???????????");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllTotalCabangProduktif(dispatch) {
  try {
    const response = await baseAxios.get(
      "webDashboardProduktif/getTotalCabang",
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({ type: "SET_ALL_TOTAL_CABANG_PRODUKTIF", data: response.data });
    // console.log(response, "???????????");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getGrafikPencairanCabangProduktif(
  dispatch,
  data,
  history
) {
  try {
    const response = await baseAxios.post(
      "webDashboardProduktif/getGrafikPencairanCabang",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    // dispatch({ type: "SET_ALL_PENCAIRAN", data: response.data });
    // console.log(response);
    return response;
  } catch (err) {
    // return err.response;
    return errorHandler(err.response);
  }
}

export async function getGrafikPencairanUserProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboardProduktif/getGrafikPencairanPerBulanByLogin",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    // dispatch({ type: "SET_ALL_PENCAIRAN", data: response.data });
    // console.log(response);
    // console.log(response, "PPPPPPPP");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getExportPengajuanProduktif(data) {
  console.log(data, "KKK");
  try {
    const response = await baseAxios.post(
      "webPengajuanProduktif/exportSementara",
      data,
      {
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      }
    );
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}
